import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Dialog } from "@angular/cdk/dialog";
import { ComponentType } from "@angular/cdk/portal";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { NewsletterDialogComponent } from "../newsletter/newsletter.component";
import { ContactDialogComponent } from "../contact/contact.component";

@Component({
  standalone: true,
  template: "", // nur controller
})
export class PopupRouteComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(Dialog);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  private sub?: Subscription;
  private opened = false;

  ngOnInit(): void {
    // verhindert doppeltes Öffnen
    if (this.opened) return;
    this.opened = true;

    const path = this.route.snapshot.routeConfig?.path ?? "newsletter";

    const dialogComponent = (
      path === "contact" ? ContactDialogComponent : NewsletterDialogComponent
    ) as ComponentType<unknown>;

    const ref = this.dialog.open(dialogComponent, {
      panelClass: path === "contact" ? "contact-dialog-panel" : "newsletter-dialog-panel",
      backdropClass:
        path === "contact" ? "contact-dialog-backdrop" : "newsletter-dialog-backdrop",
      disableClose: false,
      data: {},
    });

    this.sub = ref.closed.subscribe(() => {
      // ✅ popup outlet schließen, primary route bleibt sichtbar
      this.router.navigate([{ outlets: { popup: null } }], {
        relativeTo: this.route.parent ?? this.route,
        queryParamsHandling: "preserve",
      });
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
